import 'reflect-metadata';

export const JSON_API_PROPERTY_DECORATOR_KEY = 'JSON_API_PROPERTY_DECORATOR_KEY';

export default function JsonApiProperty(
  propertyOptions: (
    | { type: string }
    | { resolver: (value: any, attrs: Record<string, any>, data: Record<string, any>) => any }
  ) & { readOnly?: boolean }
) {
  return function (target: any, propertyKey: string) {
    const classConstructor = target.constructor;
    const metadata = Reflect.getMetadata(JSON_API_PROPERTY_DECORATOR_KEY, classConstructor) || {};
    metadata[propertyKey] = propertyOptions;
    Reflect.defineMetadata(JSON_API_PROPERTY_DECORATOR_KEY, metadata, classConstructor);
  };
}
